/**
 * Created by jv on 27/01/2017.
 */
const utils = require("Sources/utils/utils");
const request = require("Sources/services/request");
const Order = require("Sources/models/order");
const Catalog = require("Sources/models/store/catalog");
const SessionData = require("Sources/models/store/session-data");
const Error = require("Sources/models/error");

var storeServices = {};

(function(StoreServices)
{
  function dataToError(data, callback)
  {
    if(utils.isFunction(callback))
    {
      if(data.hasOwnProperty("exception"))
      {
        callback(new Error(data.exception));
      }
      else
      {
        callback(new Error({
          code: null,
          message: null
        }));
      }
    }
  }

  StoreServices.getCatalogList = function(successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("list_catalogs"),
      cache: false,
      dataType: "json",
      contentType: "application/json"
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(data.result.result["catalog-list"]);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  StoreServices.getCatalog = function(catalogKey, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("get_catalog"),
      cache: false,
      dataType: "json",
      data: {
        "catalog-key": utils.isNotNull(catalogKey) ? catalogKey : null
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(new Catalog(data.result.result));
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  StoreServices.getSessionData = function(successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("get_session_data"),
      cache: false,
      dataType: "json",
      contentType: "application/json"
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(new SessionData(data.result.result));
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  StoreServices.clearShoppingCart = function(successCb, failCb)
  {
    request.post({
      url:  utils.getServiceUrl("clear_shopping_cart"),
      cache: false,
      dataType: "json",
      contentType: "application/json"
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(new SessionData(data.result.result));
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  StoreServices.setCartArticleQuantity = function(articleKey, quantity, successCb, failCb)
  {
    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
      url:  utils.getServiceUrl("add_to_shopping_cart"),
      cache: false,
      dataType: "json",
      data: {
        "catalog-article-key": articleKey,
        "count": quantity
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(new SessionData(data.result.result));
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  StoreServices.setOrderInfo = function(orderInfo, successCb, failCb)
  {
    // Can't update order info if cart is empty
    request.post({
      url:  utils.getServiceUrl("send_order_info"),
      cache: false,
      dataType: "json",
      data: {
        "info-json": utils.stringifyJSON(orderInfo)
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(new SessionData(data.result.result));
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  StoreServices.placeOrder = function(successCb, failCb)
  {
    request.post({
      url:  utils.getServiceUrl("place_order"),
      cache: false
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(new Order(data.result.result));
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  StoreServices.getSchoolForId = function(identification, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("get_school"),
      cache: false,
      data: {
        "number": identification
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(data.result.result);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  StoreServices.getOffer = function(data, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("get_offer"),
      cache: false,
      data: {
        "firstname": data.firstname,
        "lastname": data.lastname,
        "email": data.email,
        "organisation": data.organisation
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(data.result.result);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  StoreServices.getPaymentStatus = function(orderNumber, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("get_payment_status"),
      cache: false,
      data: {
        "order-number": orderNumber
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(data.result.result);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

}(storeServices));

module.exports = storeServices;



// WEBPACK FOOTER //
// ./app/js/services/fundels/store-services.js